export const DEFAULT_LIST_WIDTH = 420;
export const MIN_LIST_WIDTH = 360;
export const MAX_LIST_WIDTH = 480;
export const MIN_SAVED_LIST_WIDTH = 280;

export const clampListWidth = (value, min = MIN_LIST_WIDTH, max = MAX_LIST_WIDTH) =>
  Math.min(Math.max(Number(value) || DEFAULT_LIST_WIDTH, min), max);

// Measure the unscaled content area, so fitting never feeds back into its own size.
export function getTicketsFit(width, height, allowScale = true) {
  if (!Number.isFinite(width) || !Number.isFinite(height) || !(width > 0) || !(height > 0)) {
    return { scale: 1, minListWidth: MIN_LIST_WIDTH, maxListWidth: MAX_LIST_WIDTH };
  }
  const scale = allowScale
    ? Math.round(Math.max(0.9, Math.min(1, width / 1280, height / 800)) * 100) / 100
    : 1;
  const maxListWidth = Math.max(280, Math.min(MAX_LIST_WIDTH, Math.floor(width / scale - 12 - 560)));
  return { scale, minListWidth: Math.min(MIN_LIST_WIDTH, maxListWidth), maxListWidth };
}

// Pointer coordinates are visual pixels; persisted widths are unscaled CSS pixels.
export const getDraggedListWidth = (clientX, left, scale, min, max) =>
  Math.round(Math.min(Math.max((clientX - left) / scale, min), max));
